import React from "react";
import { I18nextProvider } from "react-i18next";
import GlobalStyle from "./styles";
import { i18n } from "./config";
import Main from "./pages/Main";

const App = () => (
  <>
    <GlobalStyle />
    <I18nextProvider i18n={i18n}>
      <Main />
    </I18nextProvider>
  </>
);

export default App;
